import { cn } from "../../../lib/utils.mjs";
import { jsx } from "react/jsx-runtime";

//#region src/components/ui/retail-storefront/skeleton.tsx
function Skeleton({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("animate-pulse rounded-md bg-primary/10", className),
		...props
	});
}

//#endregion
export { Skeleton };
//# sourceMappingURL=skeleton.mjs.map